export const DO_BASE_URL = process.env.REACT_APP_BASE_URL;
export const DO_CENTRAL_SERVICE_URL =
  process.env.REACT_APP_DO_CENTRAL_SERVICE_URL;
export const DO_CODE_EDITOR_LIBRARY_URL =
  process.env.REACT_APP_DO_CODE_EDITOR_LIBRARY_URL;
export const DO_WEBSOCKET_SERVICE_URL =
  process.env.REACT_APP_DO_WEBSOCKET_SERVICE_URL;
export const DO_INTERVIEW_SERVICE_URL =
  process.env.REACT_APP_INTERVIEW_SERVICE_URL;
export const ZOOM_SDK_KEY = process.env.REACT_APP_ZOOM_SDK_KEY; // TODO: move this to env in M2
export const ZOOM_SDK_SECRET = process.env.REACT_APP_ZOOM_SDK_SECRET; // TODO: move this to env in M2
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const INTERVIEW_END_HARD_LIMIT_IN_SECONDS = 3 * 60 * 60; // 3 hours in seconds
export const INTERIEW_PRE_END_MESSAGE_BEFORE = 5;

export const TERMS_OF_SERVICE_URL =
  "https://doselect.zendesk.com/hc/en-us/articles/205976232";
export const ENVIRONMENT_DETAILS_URL =
  "https://doselect.zendesk.com/hc/en-us/articles/205536631-Scripting-environment-details";
export const RIGHTS_RESERVED = `© ${new Date().getFullYear()} Doselect. All rights reserved.`;
export const DOSELECT_SUPPORT_EMAIL = "support@doselect.com";

export const ONE_MINUTE_IN_MILI_SECONDS = 60000;
